/** Rendered as labelled progress bars; `level` is a percentage. */
export const skills = [
  { name: "HTML/CSS", level: 90 },
  { name: "JavaScript/Typescript", level: 85 },
  { name: "React/Svelte", level: 75 },
  { name: "Angular", level: 65 },
  { name: "Django/SpringBoot", level: 70 },
  { name: "Python, Java", level: 85 },
  { name: "PHP", level: 75 },
  { name: "MySQL/PostgreSQL", level: 75 },
  { name: "NGINX/Docker/GIT", level: 65 },
];
